var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManpowerGpH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 432 77.4",
    style: {
      enableBackground: "new 0 0 432 77.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M110,25.8l9.9,26.4l9.9-26.4h5.7v31.4h-4V31.1h-0.1l-9.8,26.1h-3.6l-9.8-26.1h-0.1v26.1h-4V25.8H110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M150.4,33.9c5.7,0,8.5,2,8.5,6.1v13.1c0,0.9,0.4,1.3,1.2,1.3c0.4,0,0.8-0.1,1.1-0.2v2.9 c-0.8,0.4-1.8,0.6-2.7,0.6c-2.1,0-3.2-1.2-3.2-3.5c-2,2.3-4.9,3.6-8,3.5c-2,0.1-3.9-0.5-5.5-1.7c-1.4-1.2-2.1-2.9-2-4.7 c-0.1-1.8,0.6-3.6,2-4.8c1.3-1.2,4.4-2.1,9.2-2.7c1.2-0.1,2.3-0.4,3.3-0.9c0.6-0.4,0.9-1.1,0.9-1.9c0-2.5-1.7-3.7-5.1-3.7 c-1.5-0.1-2.9,0.3-4.2,1c-1,0.8-1.5,2-1.5,3.3h-3.7C141.1,36.4,144.3,33.9,150.4,33.9z M143.8,51.1c0,1,0.4,1.9,1.1,2.5 c1,0.6,2.1,1,3.3,0.9c1.8,0.1,3.5-0.5,5-1.5c1.2-0.8,1.9-2.1,2-3.6v-3.9c-0.8,0.5-1.7,0.8-2.6,0.9l-3.8,0.6 c-1.3,0.1-2.6,0.6-3.7,1.3C144.2,49,143.8,50,143.8,51.1L143.8,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M175.7,33.9c5.2,0,7.8,2.7,7.8,8.1v15.1h-3.7V41.7c0-1.2-0.4-2.3-1.2-3.2c-0.9-0.9-2.2-1.4-3.5-1.3 c-1.9-0.1-3.7,0.6-5,1.9c-1.2,1.4-1.8,3.2-1.7,5.1v13h-3.7V34.4h3.5V38h0.1C169.8,35.4,172.7,33.8,175.7,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M199.6,33.9c2.9-0.1,5.7,1.1,7.7,3.3c2,2.5,3,5.5,2.8,8.7c0.1,3.1-0.9,6.2-2.8,8.6c-1.9,2.2-4.7,3.4-7.5,3.3 c-1.4,0-2.8-0.3-4.1-0.9c-1.3-0.6-2.4-1.5-3.2-2.7h-0.1v11.7h-3.7V34.4h3.7v3.1h0.1C193.5,35.1,196,33.9,199.6,33.9z M192.1,45.8 c-0.1,2.3,0.5,4.5,1.9,6.3c1.3,1.6,3.3,2.4,5.3,2.3c2,0.1,3.8-0.8,5-2.3c1.3-1.9,1.9-4.2,1.8-6.5c0.1-2.2-0.6-4.3-1.9-6.1 c-1.3-1.5-3.2-2.4-5.2-2.3c-1.9-0.1-3.8,0.8-5,2.3C192.6,41.3,192,43.5,192.1,45.8L192.1,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M223.7,33.9c3-0.1,6,1,8.1,3.3c4,5.1,4,12.2,0,17.2c-2.1,2.3-5,3.5-8.1,3.3c-3,0.1-5.9-1-8-3.2 c-2.1-2.4-3.2-5.5-3-8.6c-0.2-3.2,0.9-6.3,3-8.7C217.8,34.9,220.7,33.8,223.7,33.9z M216.7,45.8c-0.1,2.2,0.6,4.4,2,6.2 c2.4,2.8,6.6,3.2,9.4,0.8c0.3-0.2,0.6-0.5,0.8-0.8c1.4-1.8,2.1-4,2-6.2c0.1-2.2-0.6-4.5-2-6.2c-1.2-1.6-3.2-2.5-5.1-2.4 c-2,0-3.8,0.9-5,2.4C217.3,41.4,216.6,43.6,216.7,45.8L216.7,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M240.2,34.4l5.1,18.6h0.1l4.6-18.6h4.1l4.8,18.6h0l5.1-18.6h3.9l-7.2,22.7l0,0h-4L252,39.1h0l-4.6,18.1h-4 L236,34.4L240.2,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M279.4,33.9c2.9-0.1,5.8,1.2,7.6,3.5c1.9,2.6,2.9,5.8,2.7,9.1v0.4h-17v0.3c-0.1,1.9,0.6,3.8,1.9,5.3 c1.4,1.4,3.3,2.1,5.2,2c3.3,0,5.2-1.5,5.9-4.4h3.7c-0.3,2.3-1.5,4.3-3.3,5.8c-1.9,1.4-4.1,2-6.4,2c-3.6,0-6.3-1.2-8.1-3.5 c-1.9-2.4-2.9-5.5-2.8-8.5c-0.1-3.1,1-6.1,3-8.4C273.7,35.1,276.5,33.8,279.4,33.9z M285.7,43.6c-0.1-1.7-0.8-3.4-2-4.6 c-1.2-1.2-2.9-1.9-4.6-1.8c-1.6,0-3.2,0.6-4.4,1.7c-1.2,1.3-2,2.9-2.1,4.7H285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M305.5,33.9v4c-2.8,0-4.9,0.7-6.2,2.2c-1.3,1.5-2,3.8-2,6.9v10.2h-3.7V34.4h3.5v4.8h0.1 c1.7-3.5,4.3-5.3,7.8-5.3L305.5,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M322.8,25c3.3-0.1,6.5,0.8,9.2,2.7c2.5,1.9,4,4.7,4.3,7.8h-4.2c-0.3-2-1.4-3.9-3-5.1c-1.8-1.3-4.1-1.9-6.3-1.8 c-3-0.1-5.9,1.2-7.8,3.6c-2,2.4-2.9,5.6-2.9,9.7c-0.1,3.2,0.9,6.4,3,8.9c1.9,2.4,4.8,3.7,7.8,3.6c2.7,0.1,5.3-0.9,7.2-2.7 c1.9-1.8,3-4.4,2.9-7.1v-0.5h-10v-3.5h13.8v16.5H334l-1.1-3.9c-1.1,1.5-2.6,2.7-4.4,3.5c-1.8,0.8-3.7,1.2-5.7,1.2 c-4.1,0.1-8-1.6-10.7-4.6c-2.8-3-4.4-7.1-4.3-11.3c0-5,1.3-9.1,4-12.3C314.5,26.6,318.1,25,322.8,25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M353.6,33.9v4c-2.8,0-4.9,0.7-6.2,2.2c-1.3,1.5-2,3.8-2,6.9v10.2h-3.7V34.4h3.5v4.8h0.1 c1.7-3.5,4.3-5.3,7.8-5.3L353.6,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M365.5,33.9c3-0.1,6,1,8.1,3.3c4,5.1,4,12.2,0,17.2c-2.1,2.3-5,3.5-8.1,3.3c-3,0.1-5.9-1-8-3.2 c-2.1-2.4-3.2-5.5-3-8.6c-0.2-3.2,0.9-6.3,3-8.7C359.5,34.9,362.4,33.8,365.5,33.9z M358.4,45.8c-0.1,2.2,0.6,4.4,2,6.2 c2.4,2.8,6.6,3.2,9.4,0.8c0.3-0.2,0.6-0.5,0.8-0.8c1.4-1.8,2.1-4,2-6.2c0.1-2.2-0.6-4.5-2-6.2c-1.2-1.6-3.2-2.5-5.1-2.4 c-2,0-3.8,0.9-5,2.4C359,41.4,358.3,43.6,358.4,45.8L358.4,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M383.9,34.4v15.5c0,1.2,0.4,2.4,1.2,3.2c0.9,0.9,2.1,1.3,3.4,1.3c1.9,0.1,3.7-0.6,5-1.9 c1.2-1.4,1.8-3.2,1.7-5.1v-13h3.7v22.7h-3.5v-3.6h-0.1c-1.4,2.7-4.3,4.3-7.4,4.1c-5.2,0-7.8-2.7-7.8-8.1V34.4H383.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M415,33.9c2.9-0.1,5.7,1.1,7.7,3.3c2,2.5,3,5.5,2.8,8.7c0.1,3.1-0.9,6.2-2.8,8.6c-1.9,2.2-4.7,3.4-7.5,3.3 c-1.4,0-2.8-0.3-4.1-0.9c-1.3-0.6-2.4-1.5-3.2-2.7h-0.1v11.7h-3.7V34.4h3.7v3.1h0.1C408.9,35.1,411.3,33.9,415,33.9z M407.5,45.8 c-0.1,2.3,0.5,4.5,1.9,6.3c1.3,1.6,3.3,2.4,5.3,2.3c2,0.1,3.8-0.8,5-2.3c1.3-1.9,1.9-4.2,1.8-6.5c0.1-2.2-0.6-4.3-1.9-6.1 c-1.3-1.5-3.2-2.4-5.2-2.3c-1.9-0.1-3.8,0.8-5,2.3C408,41.3,407.4,43.5,407.5,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#386097"
    },
    d: "M8.6,46.6c-0.8,2.3-3.4,3.5-5.7,2.6c-2.3-0.8-3.5-3.4-2.6-5.7l8.9-24.5c0.8-2.3,3.4-3.5,5.7-2.6 s3.5,3.4,2.6,5.7L8.6,46.6L8.6,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4C79AF"
    },
    d: "M23.8,53c-1.1,3-4.4,4.6-7.4,3.5c-3-1.1-4.6-4.4-3.5-7.4l12.1-33.3c1.1-3,4.4-4.5,7.4-3.4 c3,1.1,4.5,4.4,3.5,7.4C35.9,19.8,23.8,53,23.8,53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5C7D70"
    },
    d: "M43,60.9c-1.5,4-5.9,6.1-10,4.6c-4-1.5-6.1-5.9-4.6-9.9l15.9-43.7c1.5-4,5.9-6.1,9.9-4.6c4,1.5,6.1,5.9,4.6,9.9 l0,0L43,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C25700"
    },
    d: "M67.1,70.7c-1.9,5.3-7.8,8.1-13.2,6.1c-5.3-1.9-8.1-7.8-6.1-13.1L68.6,6.8c1.9-5.3,7.8-8.1,13.1-6.1 s8.1,7.8,6.1,13.1c0,0,0,0,0,0L67.1,70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M425.5,27c0.2-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.7-0.5,1.1-0.7c1.7-0.7,3.7,0.1,4.4,1.8c0.2,0.4,0.3,0.9,0.3,1.3 c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.5-1.1,0.7c-0.8,0.3-1.8,0.3-2.6,0c-0.4-0.2-0.8-0.4-1.1-0.7 c-0.3-0.3-0.6-0.7-0.7-1.1c-0.2-0.4-0.3-0.9-0.3-1.3C425.2,27.9,425.3,27.5,425.5,27z M426,29.5c0.1,0.3,0.3,0.7,0.6,0.9 c0.3,0.3,0.6,0.5,0.9,0.6c0.3,0.1,0.7,0.2,1.1,0.2c0.4,0,0.7-0.1,1.1-0.2c0.3-0.1,0.6-0.3,0.9-0.6c0.3-0.3,0.5-0.6,0.6-0.9 c0.1-0.4,0.2-0.8,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1c-0.3-0.7-0.8-1.2-1.5-1.5c-0.3-0.1-0.7-0.2-1.1-0.2c-0.7,0-1.5,0.3-2,0.8 c-0.3,0.3-0.5,0.6-0.6,0.9c-0.1,0.4-0.2,0.7-0.2,1.1C425.8,28.8,425.9,29.2,426,29.5z M428.8,26.4c0.4,0,0.7,0.1,1,0.3 c0.2,0.2,0.4,0.5,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.3-0.7,0.3l1.1,1.7h-0.7l-1.1-1.7h-0.6v1.7h-0.6v-3.9H428.8z  M428.6,28.2c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.2-0.1-0.3 c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0h-0.8v1.3L428.6,28.2z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManpowerGpH);
export default __webpack_public_path__ + "static/media/manpower_gp_h.ef1d7ab3399e5d73703b0ae629c43465.svg";
export { ForwardRef as ReactComponent };